module.exports = __webpack_public_path__ + "img/lb.55e2afd8.svg";